/* The visitor's temperature unit (°C / °F) in the browser: the saved preference, else Fahrenheit in the countries that use it and Celsius elsewhere.
   The same rule as TmTemperature::getEffectiveUnit (app/shared/TmTemperature.php): keep fahrenheitCountries in step with
   its FAHRENHEIT_COUNTRIES. The preference lives in tmv-temperature (tmVisitorStore); an account's saved one
   (tm_temperature) is applied to it by tmAuth.applyTemperaturePreference, and setPreference saves a signed-in visitor's pick
   as the account's (tm_temperature_changed -> tmAuth.saveSitePreference) */
window.tmTemperature = function () {
    const fahrenheitCountries = ['US', 'PR', 'GU', 'VI', 'AS', 'MP', 'UM', 'LR', 'MM', 'BS', 'BZ', 'KY', 'PW', 'FM', 'MH'];

    function canonical(unit) {
        unit = String(unit || '').trim().toUpperCase();
        return unit === 'C' || unit === 'F' ? unit : '';
    }

    return {
        /* 'C' or 'F' as saved; '' when none is (No preference) */
        getPreference: function () {
            return canonical(tmVisitorStore.getTemperature());
        },

        /* saves 'C' or 'F'; anything else ('') clears the visitor's tmv-temperature cookie only: a signed-in account's
           unit is not cleared (tm_save_site_preference refuses ''), its No preference is saved on Account settings */
        setPreference: function (unit) {
            unit = canonical(unit);
            tmVisitorStore.setTemperature(unit);
            jQuery(document).trigger('tm_temperature_changed', { unit: unit });
        },

        /* the unit to show: the preference, else by country (ISO 3166-1 alpha-2, any case; default the tmv-country
           cookie, tmVisitorStore.getCountry). An unknown country is Celsius, as in PHP. For a first visit with no
           tmv-country yet: tmVisitorStore.resolveCountry().then(tmTemperature.getEffectiveUnit) */
        getEffectiveUnit: function (country) {
            const preference = tmTemperature.getPreference();
            if (preference !== '') {
                return preference;
            }
            if (typeof country !== 'string') {
                country = tmVisitorStore.getCountry();
            }
            return fahrenheitCountries.indexOf(country.trim().toUpperCase()) !== -1 ? 'F' : 'C';
        }
    };
}();
